import LandDealsContainer from './LandDealsContainer';

export default LandDealsContainer;
